<template>
  <div style="background: #f9f9f9; height: calc(100vh - 44px)">
    <div class="head-nav d-aligncnter">
      <div class="nav-left d-allcenter">
        <!-- <img src="@/assets/img/appointment/back.svg" /> -->
      </div>
      <div class="nav-title d-allcenter overflow">预约结果</div>
      <div class="nav-right d-allcenter" style="font-size: 12px"></div>
    </div>
    <div class="content d-aligncnter d-column d-allcenter">
      <div
        style="width: 72px; height: 72px; border-radius: 50%; background: #339571; margin-top: 32px"
        class="d-allcenter"
      >
        <img src="@/assets/img/appointment/check-small.svg" />
      </div>
      <div style="margin-top: 16px" class="weight fs-lg">恭喜您，预约成功！</div>
      <div style="margin-top: 16px; padding: 0 32px" class="grey">
        预约结果可在“我的预约”查看。若您无法按时到馆，请您提前取消预约，具体退费规则请查看预约须知。以下是您的预约信息：
      </div>
      <div class="order-info">
        <div class="info-box">
          <div class="d-aligncnter">
            <div style="width: 80px; height: 80px; border-radius: 2px; overflow: hidden" class="d-allcenter">
              <el-image
                style="width: 80px; height: 64px"
                :src="require('@/assets/img/appointment/demo.png')"
                fit="cover"
              ></el-image>
            </div>
            <div style="margin-left: 16px; font-size: 14px; width: calc(100% - 100px)">
              <div class="weight overflow2">
                {{ currOrderData.venueName }}（{{ currOrderData.areaName }}{{ currOrderData.blockName }}）
              </div>
              <div class="grey mt-4">{{ currOrderData.date }} {{ currOrderData.time }}</div>
              <div class="grey mt-4">预约人数：{{ currOrderData.num }}</div>
            </div>
          </div>
        </div>
        <div style="padding: 16px">
          <div
            class="d-aligncnter d-between"
            style="padding: 2px 0"
            v-for="(item, index) in currOrderData.users"
            :key="'order_' + index"
          >
            <div class="fs-xs d-aligncnter">
              {{ index + 1 }}.{{ item.name }}
              <div
                style="color: #fff; background: #e14c46; padding: 2px 4px; border-radius: 90px; margin-left: 8px"
                v-if="item.main"
              >
                预约人
              </div>
            </div>
            <div class="grey" style="margin-left: 16px">{{ item.mobile }}</div>
          </div>
          <!-- <div class="d-aligncnter d-between">
            <div class="fs-xs">2.李四</div>
            <div class="grey" style="margin-left: 16px">152****6666</div>
          </div>
          <div class="d-aligncnter d-between">
            <div class="fs-xs">1.张三</div>
            <div class="grey" style="margin-left: 16px">152****6666</div>
          </div>
          <div class="d-aligncnter d-between">
            <div class="fs-xs">2.李四</div>
            <div class="grey" style="margin-left: 16px">152****6666</div>
          </div> -->
        </div>
        <!-- <div class="d-aligncnter">
          <div class="grey">场地</div>
          <div style="margin-left: 16px">北校区龙狮足球场1号场地</div>
        </div>
        <div class="d-aligncnter" style="margin-top: 4px">
          <div class="grey">日期</div>
          <div style="margin-left: 16px">2023-09-09 10:00-11:00</div>
        </div>
        <div class="d-aligncnter" style="margin-top: 4px">
          <div class="grey">姓名</div>
          <div style="margin-left: 16px">张三</div>
        </div>
        <div class="d-aligncnter" style="margin-top: 4px">
          <div class="grey">手机</div>
          <div style="margin-left: 16px">15288888888</div>
        </div>
        <div class="d-aligncnter" style="margin-top: 4px">
          <div class="grey">费用</div>
          <div style="margin-left: 16px">￥25</div>
        </div> -->
      </div>
    </div>
    <div class="d-allcenter" style="position: fixed; bottom: 32px; width: 100vw">
      <button class="save-btn" style="width: calc(100% - 64px)" @click="pageToIndex">返回首页</button>
    </div>
  </div>
</template>
<script>
import { Message } from 'element-ui'
import EventBus from '@/assets/js/EventBus'
import { getConferenceResult } from '@/api/api-venueOrder'
export default {
  data() {
    return {
      phone: '',
      userInfo: { headImg: '', name: '', mobile: '' },
      rightText: '编辑',
      radio: 0,
      conferenceId: '',
      currOrderData: {},
    }
  },
  mounted() {
    this.conferenceId = this.$route.query.conferenceId
    this.getCurrConferenceData()
  },
  methods: {
    getCurrConferenceData() {
      getConferenceResult(this.conferenceId).then((res) => {
        if (res.data.statusCode == 1) {
          console.log('res:', res)
          this.currOrderData = res.data.obj
        } else {
          Message.error(res.data.message)
        }
      })
    },
    pageToIndex() {
      this.$router.push({ path: '/appointment/index' })
      EventBus.$emit('refreshOrderList')
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/appoint.scss';

.mt-16 {
  margin-top: 16px;
}
.content {
  padding: 0;
  background: #f9f9f9;
}
.each {
  background: #f9f9f9;
  box-shadow: 0px -1px 0px 0px #e8e8e8 inset;
  padding: 8px 16px;
  min-height: 32px;
  color: #181818;
}
.photo {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #d4a3fc;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
  }
}
.save-btn {
  border-radius: 52px;
  //   background: linear-gradient(270deg, #2f2f2f 0%, #464646 100%);
  background: #fff;
  width: 343px;
  height: 42px;
  border: 1px solid #d1d1d1;
  color: #2f2f2f;
  font-size: 14px;
  margin-top: 16px;
  //   position: absolute;
  //   bottom: 152px;
}
.ml-16 {
  margin-left: 16px;
}
.order-info {
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 2px 4px 0px #e8e8e8;
  //   padding: 16px;
  margin: 16px;
  width: calc(100% - 64px);
}
.info-box {
  border-radius: 8px 8px 0 0;
  background: linear-gradient(302deg, #e6f2ed 0%, #fff8e7 100%), #fff;
  //   box-shadow: 0px 2px 4px 0px #e8e8e8;
  //   margin: 16px;
  padding: 16px;
}
.mt-4 {
  margin-top: 4px;
}
</style>
